<template>
  <v-container
    class="align-content-start pa-0"
    fill-height
    fluid
  >
    <v-row>
      <v-col
        v-if="Deposits.DescriptiveStatistics"
        cols="12"
        lg="4"
        md="4"
      >
        <descriptive-statistics :risk-analysis-id="accountId" />
      </v-col>

      <v-col
        v-if="Deposits.DescriptiveStatistics"
        cols="12"
        lg="8"
        md="8"
      >
        <time-deposits :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="4"
        class="d-flex"
      >
        <deposit-yields
          class="flex-grow-1 fill-height"
          :risk-analysis-id="accountId"
        />
      </v-col>

      <v-col
        v-if="Deposits.TypeAllocation"
        cols="12"
        md="8"
        class="d-flex"
      >
        <deposit-type-allocation
          class="flex-grow-1 fill-height"
          :risk-analysis-id="accountId"
        />
      </v-col>
    </v-row>

    <!-- Dynamic Evolution Row -->
    <v-row>
      <v-col
        v-if="Deposits.DynamicEvolution"
        cols="12"
      >
        <dynamic-evolution :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <!-- Deposit Concentration Row -->
    <v-row>
      <v-col
        v-if="Deposits.DepositsConcentration"
        cols="12"
        lg="8"
        md="6"
      >
        <deposit-concentration :risk-analysis-id="accountId" />
      </v-col>
      <v-col
        v-if="Deposits.FixedFloatingComparison"
        cols="12"
        lg="4"
        md="6"
      >
        <fixed-vs-floating-rates :risk-analysis-id="accountId" />
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API                               from '@/api/Api'
import { clone }                         from '@/lib/utils/helper'
import ALMDepositsResource from '@/api/resources/alm/ALMDepositsResource'
import DescriptiveStatistics from '@/theme/default/views/banking/alm/deposits/blocks/DescriptiveStatistics.vue'
import AssetModel from '@/api/models/asset/AssetModel'
import TimeDeposits from '@/theme/default/views/banking/alm/deposits/blocks/TimeDeposits.vue'
import DynamicEvolution from '@/theme/default/views/banking/alm/deposits/blocks/DynamicEvolution.vue'
import DepositConcentration from '@/theme/default/views/banking/alm/deposits/blocks/DepositConcentration.vue'
import FixedVsFloatingRates from '@/theme/default/views/banking/alm/deposits/blocks/FixedVsFloatingRates.vue'
import DepositTypeAllocation from '@/theme/default/views/banking/alm/deposits/blocks/DepositTypeAllocation.vue'
import DepositYields from '@/theme/default/views/banking/alm/deposits/blocks/DepositYields.vue'

export default {
  name      : 'ALMDepositsPortfolio',
  components: {
    DescriptiveStatistics,
    TimeDeposits,
    DynamicEvolution,
    DepositConcentration,
    FixedVsFloatingRates,
    DepositTypeAllocation,
    DepositYields
  },
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {
    selectedDate: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    appToolbarExtended: 'App.Config.AppToolbarExtended',

    Deposits: 'ALM.Deposits.Data',

    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    },
    selectedDate: {
      handler (newDate) {
        if (newDate && newDate.trim() !== '') {
          this.getData()
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.selectedDate && this.selectedDate.trim() !== '') {
      this.getData()
    }
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {
    getData () {
      const params = this.selectedDate ? [this.accountId, this.selectedDate] : [this.accountId]
      API.Resource.ALM.GetALMDeposits(...params)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.Deposits = new ALMDepositsResource(o)

        this.$set(this.riskBaseCurrencyData, this.accountId, new AssetModel(o.baseCurrency ?? null))
      } else {
        this.Deposits = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
  </script>

  <style scoped>

  </style>
